import app from 'flarum/forum/app';
import {initChat} from '@speareducation/talkjs';
import NotificationsDropdown from 'flarum/forum/components/NotificationsDropdown';

/**
 * It may be tempting to NOT extend NotificationsDropdown, but I wanted to do so in order to keep the same Object structure
 * due to CSS class tree and nav consistency. There are a few dropdowns in the nav, and they all use this class.
 */
export default class MessagesNavButton extends NotificationsDropdown {

    unreadMessageCount = 0;

    isOpen = false;

    static initAttrs(attrs) {
        attrs.className ||= 'NotificationsDropdown MessagesNavButton';
        attrs.icon = 'fas fa-comment-alt';
        attrs.accessibleToggleLabel = 'Messages';
        attrs.label = 'Messages';
        super.initAttrs(attrs);
    }

    /**
     * Parent overrides
     */

    oncreate(vnode) {
        this.element = vnode.dom; // Skip super.oncreate because of weird mithril/bs overrides
        this.watchUnreads();
    }

    onclick(e) {
        e.stopPropagation();
        e.preventDefault();

        if (m.route.get() === app.route('messages.inbox') || app.drawer.isOpen()) {
            m.route.set(app.route('messages.inbox'));
        } else {
            this.initInbox(); // check if Inbox is initialized on every click in case Mithril clears it or something.
            this.toggleDropdown();
        }
    }

    /**
     * Because Mithril & Bootstrap 3 don't really compat and I can't figure out how the <redacted> it actually toggles,
     * I'm just going to trigger this manually based on observed DOM changes.
     * For example, we should be able to run $('.Dropdown').dropdown('toggle'); but this only works on first run. I cannot
     * seem to find a way to force the dropdown closed externally.
     * @param {Boolean?} toggle
     */
    toggleDropdown(toggle = null) {
        let desiredState = toggle !== null ? toggle : !this.isOpen;
        this.element.classList.toggle('open', desiredState);
        this.element.toggleAttribute('aria-expanded', desiredState);
    }

    getButton(children) {
        const vdom = super.getButton(children);
        vdom.attrs.onclick = (e) => this.onclick(e, vdom);
        return vdom;
    }

    getNewCount() {
        return this.unreadMessageCount;
    }

    getUnreadCount() {
        return this.unreadMessageCount;
    }

    /**
     * Custom methods
     */

    async watchUnreads() {
        const chat = await initChat();

        chat.watchUnreads(unreadList => {
            this.unreadMessageCount = unreadList.reduce((total, entry) => total + entry?.unreadMessageCount, 0);
            m.redraw();
        });
    }

    async initInbox() {
        const container = document.getElementById('navMessageContainer');
        if (!container) {
            console.error('#navMessageContainer not found!');
            return;
        }
        const hasIframe = container?.getElementsByTagName('iframe')?.length > 0;
        if (hasIframe) {
            return; // already mounted
        }

        const chat = await initChat();
        const inbox = chat.createInbox({
            showChatHeader: false,
            showFeedHeader: false,
            selected: null,
            useBrowserHistory: false,
            theme: 'spear_dashboard_dropdown',
        });
        inbox.mount(container);

        inbox.onSelectConversation(e => {
            if ('preventDefault' in e && typeof (e.preventDefault) === 'function') {
                e.preventDefault();
            }
            const popover = chat.getPopover({ theme: 'spear_default', launcher: 'close-only', keepOpen: false });
            popover.select(e.conversation.id);
            popover.show();
            this.toggleDropdown(false);

            return false;
        });
    }

    getMenu() {
        return (
            <div className="Dropdown-menu Dropdown-menu--right">
                <div className="NotificationList">
                    <div className="NotificationList-header">
                        <h4 className="App-titleControl App-titleControl--text">Messages</h4>
                        <div className="App-primaryControl">
                            <a href={app.route('messages.inbox')}>View All</a>
                        </div>
                    </div>
                    <div id="navMessageContainer" className="NotificationList-content" style="height:350px; max-height:80vh;"></div>
                </div>
            </div>
        );
    }

}
